(() => {
  const populateContact = () => {
    const { email } = EvoXLayer().session.default_branch || {};
    const { phone } = EvoXLayer().session.default_branch || {};
    const { address } = EvoXLayer().session.default_branch || {};

    const emails = document.querySelectorAll('.js-contact-email') || [];
    const phones = document.querySelectorAll('.js-contact-phone') || [];
    const addresses = document.querySelectorAll('.js-contact-address') || [];

    emails.forEach((emailElement) => {
      emailElement.innerHTML = `<a href="mailto:${email}">${email}</a>`;
    });

    phones.forEach((phoneElement) => {
      phoneElement.innerHTML = `<a href="tel:${phone}">${phone}</a>`;
    });

    addresses.forEach((addressElement) => {
      addressElement.innerHTML = [
        address.line_1,
        address.line_2,
        address.line_3,
        address.city,
        address.state,
        address.zip,
        address.country,
      ].filter(Boolean).join(', ');
    });
  };

  $(document).ready(() => {
    populateContact();
  });
})();

(() => {
  const loginhelp = document.querySelector('.ex-loggedout .login-help-wrapper');
  if (loginhelp) {
    document.querySelector('.header-right').appendChild(loginhelp.cloneNode(true));
  }

  const accountButton = document.querySelector('.ex-loggedin .account-btn');
  if (accountButton) {
    document.querySelector('.header-right').appendChild(accountButton.cloneNode(true));
  }
})();

(() => {
  const query = document.querySelector('.ex-invoices');
  if (!query) return;

  // Function to apply status classes
  const applyStatusClasses = () => {
    const statuses = document.querySelectorAll('#ordergrid .balance + td span');
    statuses.forEach((status) => {
      const text = status.textContent.trim().toLowerCase();
      // Remove existing status classes first
      status.classList.remove('status', 'status--not-paid', 'status--paid', 'status--pending');

      if (text === 'not paid') {
        status.classList.add('status', 'status--not-paid');
      } else if (text === 'paid') {
        status.classList.add('status', 'status--paid');
      } else if (text === 'pending') {
        status.classList.add('status', 'status--pending');
      }
    });
  };

  // Apply status classes initially
  applyStatusClasses();

  // Set up MutationObserver to watch for changes to the table
  const targetTable = document.querySelector('#ordergrid');
  if (targetTable) {
    const observer = new MutationObserver(() => {
      // Small delay to ensure DOM is fully updated
      setTimeout(applyStatusClasses, 1);
    });

    // Start observing the table for changes
    observer.observe(targetTable, {
      childList: true,
      subtree: true,
    });
  }
})();
